module.exports = __webpack_public_path__ + "img/circle-square.c7bc5a59.svg";